import { render, staticRenderFns } from "./VideoRow.vue?vue&type=template&id=11bb8a10&scoped=true"
import script from "./VideoRow.vue?vue&type=script&lang=js"
export * from "./VideoRow.vue?vue&type=script&lang=js"
import style0 from "./VideoRow.vue?vue&type=style&index=0&id=11bb8a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb8a10",
  null
  
)

export default component.exports